import { render } from "./PCCantidadesReservadasSinPedido.vue?vue&type=template&id=782a7c16&scoped=true"
import script from "./PCCantidadesReservadasSinPedido.vue?vue&type=script&lang=js"
export * from "./PCCantidadesReservadasSinPedido.vue?vue&type=script&lang=js"

import "./PCCantidadesReservadasSinPedido.vue?vue&type=style&index=0&id=782a7c16&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782a7c16"]])

export default __exports__